import { CarcinogenicReportWorker, CarcinogenicReportWorkerRisk } from "./types";

export const isExposed = (worker: CarcinogenicReportWorker): boolean => {
    return worker?.puestoTrabajo?.riesgos?.some(
        (risk: CarcinogenicReportWorkerRisk) => risk.cancerigeno === true
    );
};


export const getItemFromId = (id: number, array: any) => {
    const item = array?.find((item: any) => item.id === id);
    return item || '-';
};
